module.exports = __webpack_public_path__ + "img/item_Story_26.c939a8f3.jpeg";